import Environment from '@di-shared/features/environment/Environment';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingNavigationUpdateBottomSheet/.kr';

export default function SafeDrivingNavigationUpdateBottomSheet() {
  return (
    <>
      <Environment.Kr>
        <Kr />
      </Environment.Kr>
    </>
  );
}
